<script lang="ts" setup>
import { ModalsContainer } from 'vue-final-modal'
const cssVarStyles = useState('cssVarStyles', () => ({}))

</script>

<template>
  <NuxtLayout :style="{...cssVarStyles }">
    <ShadcnSonner />
    <NuxtLoadingIndicator />
    <NuxtPage />
    <ClientOnly>
      <ModalsContainer />
    </ClientOnly>
  </NuxtLayout>
</template>

<style lang="scss">
@import './assets/scss/autoloaded/theme.scss';
@import './assets/scss/autoloaded/app.scss';
@import './assets/scss/autoloaded/fonts.scss';
</style>
